import styled from 'styled-components';
import { palette } from 'styled-tools';

import { FontSizes, Text, TextElements, units } from '@calm-web/design-system';

export const NoResults = styled.div`
	width: 100%;
	color: ${palette('adaptiveText', 'white')};
	padding: ${units(2.5)};
`;

export const GridSearchResultsStyled = styled.div`
	width: 100%;
`;

export const RegularText = styled(Text).attrs({
	el: TextElements.P,
	size: FontSizes.base,
})``;
